import React, { useRef, useEffect } from 'react';
import {useAssetsImage} from '~/pages/context/AssetsImageContext';
function ToastNotification({ show, message, autohide = true, delay = 2500 }) {
    const toastRef = useRef();
    const {getImageUrlById} = useAssetsImage();
    useEffect(() => {
        if (!toastRef.current) return;
        const toast = new window.bootstrap.Toast(toastRef.current, {autohide, delay});
        if (show) {
            toast.show();
        } else {
            toast.hide();
        }
        return () => {
            toast.dispose();
        };
    }, [show]);

    return (
        <div
            ref={toastRef}
            className="toast fade position-fixed end-0 p-3 z-1"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            style={{ top: "55px" }}
        >
            <div className="toast-header">
                {
                    getImageUrlById(39) &&
                    <img src={getImageUrlById(39)} alt="breakthrough" width="35" className="me-2"/>
                }
                <strong className="me-auto fs-8-1">Notification</strong>
                <span className="fs-9 me-2">just now</span>
                <button type="button" className="btn-close" data-bs-dismiss="toast"></button>
            </div>
            <div className="toast-body">
               <span className='fs-8-1'>{message}</span>
            </div>
        </div>
    );
}

export default ToastNotification;
